<div class="button-container">
   <p-button
      (onClick)="changeZoomManual()"
      [pTooltip]="isZoomable ? 'Bloquear zoom' : 'Desbloquear zoom'"
      [tooltipPosition]="'bottom'"
      [iconPos]="'left'"
      severity="secondary"
      [raised]="true"
      [icon]="isZoomable ? 'pi pi-lock-open' : 'pi pi-lock'"
   ></p-button>
   <p-button
      (onClick)="center()"
      [pTooltip]="'Centrar Nodos'"
      [tooltipPosition]="'bottom'"
      [raised]="true"
      severity="secondary"
      [iconPos]="'left'"
      [icon]="'pi pi-window-maximize'"
   ></p-button>
   <p-button
      (onClick)="zoomIn()"
      [pTooltip]="'Acercar'"
      severity="secondary"
      [tooltipPosition]="'bottom'"
      [raised]="true"
      [iconPos]="'left'"
      [icon]="'pi pi-plus'"
   ></p-button>
   <p-button
      (onClick)="zoomOut()"
      severity="secondary"
      [pTooltip]="'Alejar'"
      [raised]="true"
      [tooltipPosition]="'bottom'"
      [iconPos]="'left'"
      [icon]="'pi pi-minus'"
   ></p-button>
   <p-button
      (onClick)="download()"
      severity="secondary"
      [pTooltip]="'Descargar imagen'"
      [raised]="true"
      [tooltipPosition]="'bottom'"
      [iconPos]="'left'"
      [icon]="'pi pi-download'"
   ></p-button>
</div>
